import React, {Component} from 'react';
import Team from '../common/Team';

class TeamPage extends Component{
    render() {
        return (
            <div>
                <Team />
            </div>

        );
    }
}

export default TeamPage;